module.exports = __webpack_public_path__ + "img/weibo.06828645.jpg";